module.exports = __webpack_public_path__ + "static/media/338.2febace0.svg";